module.exports = __webpack_public_path__ + "media/img/frond_end_agnets_card-01-f22c52ba2d21c54841ca396e7cc761d5.svg";